export default __webpack_public_path__ + "static/media/icon_cadastrar_cliente.433a83db.svg";